import { generateElementID } from '../../../../utils/generateElementID'

export const getNewTableRowData = (names: string[]) => {
    let result = { element_id: generateElementID() }
    names.map((el: any) => (result = { ...result, [el]: null }))

    return result
}
